import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/Workspaces/Video/Objects/Object/Blobs'
import { videoObjectLayoutRoute, videoObjectRoute } from 'pages/NWPlatform/Workspaces/Workspace/Video/Objects/Object'

export const videoObjectBlobsRoute = createRoute({
  getParentRoute: () => videoObjectRoute,
  path: StaticRouteParameter.BLOBS,
  loader: () => ({
    crumb: t('entity:content.blob', { count: 2 }),
  }),
})

export const videoObjectBlobsOverviewRoute = createRoute({
  getParentRoute: () => videoObjectLayoutRoute,
  path: StaticRouteParameter.BLOBS,
  component: Overview,
})
